import { Theme } from '..';

export const getThemeColor =
  (color: keyof Theme['colors']) =>
  ({ theme }: { theme: Theme }) => {
    return theme?.colors[color];
  };
